export type CallDirection = 'outgoing' | 'incoming' | 'unknown';

/**
 * originalFrom/originalToと紐づくadvisorの電話番号を照合し、架電・受電を判定する。
 *
 * @param originalFrom - 発信元電話番号（recordingのoriginalFrom）
 * @param originalTo   - 着信先電話番号（recordingのoriginalTo）
 * @param advisorPhone - 紐づくadvisorの電話番号（nullならadvisor未紐付け）
 * @returns 'outgoing'（架電）, 'incoming'（受電）, 'unknown'（判別不能）
 */
export const determineCallDirection = (
  originalFrom: string | null,
  originalTo: string | null,
  advisorPhone: string | null
): CallDirection => {
  if (advisorPhone === null) {
    return 'unknown';
  }

  const fromMatchesAdvisor = originalFrom === advisorPhone;
  const toMatchesAdvisor = originalTo === advisorPhone;

  if (fromMatchesAdvisor && !toMatchesAdvisor) {
    return 'outgoing';
  }
  if (!fromMatchesAdvisor && toMatchesAdvisor) {
    return 'incoming';
  }
  return 'unknown';
};
